import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-energyuse',
  templateUrl: './energyuse.component.html',
  styleUrls: ['./energyuse.component.css']
})
export class EnergyuseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
